<template>
    <div style="width: 100%; background-color: #ffffff; margin: 0 auto;">
            <div class="main_img"  id="main_img" :style="{height:data.devHeight}">
                <img :src="$publicPath+'/images/company/c2.png'" style="height:100%;width: 100%;" />
            </div>
        <div style="width: 90%;margin:0 auto;">
            <div  style="margin-top: 25px; display: inline-block; width: 99%;">
                <a-typography-title style="font-family: Alibaba Medium;">公司简介</a-typography-title>
            </div>
            <div style="width: 45%; display: inline-block; text-align: right; float: left; ">
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%; font-size: 20px;">
                        上海融德机电工程设备有限公司，创建于1996年
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size:20px;font-weight: bold;">
                        上海市高新技术企业
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                        上海市科技小巨人企业
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                        上海市专精特新企业
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size:20px;font-weight: bold;">
                        上海市文明单位
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:2%;font-size: 20px;font-weight: bold;">
                        中国船舶工业联营企业成员
                    </a-typography-paragraph>
                    <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:40px; font-size: 20px;">
                        集科研、生产、工程、服务为一体的高科技公司，总部位于浦东陆家嘴地区。
                    </a-typography-paragraph>
            </div>
            <div style="width: 55%;display: inline-block; padding-left: 5%;">
                    <img :src="$publicPath+'/images/company/c1.jpg'" style="width:100%;height: 500px;border-radius: 10px;" />
                </div>
<div style="display: inline-flex;width: 100%;">
    <div style="width:45%; display:inline-block; text-align: right; ">
        <a-image :preview="false" :src="$publicPath+'/images/company/c3.png'" style="width:100%; height: 500px;border-radius: 10px; "/>
    </div>
    <div style="width:55%; border:0px solid red; display: inline-flex; text-align: left;padding-left: 90px;">
        <a-typography-paragraph style="font-family: Alibaba Medium;margin-top:8%;">
            <p style="margin-top:30px;font-size:20px;">
                公司于2003年通过ISO 9001质量管理体系认证；
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                2004年取得上海市及浦东新区“计量器具生产制造许可证”；
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                2018年通过 ISO 14001环境管理体系认证及 ISO 8001职业健康安全管理体系认证；
            </p>
            <p style="margin-top:30px;font-size:20px;">
                2020年通过GJB9001C国军标质量体系管理认证。
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                融德机电产品目前获得CCS、ABS、BV、DNV、LR、NK、RS、RINA、KR等各大船级社型式认可证书近50余份;
            </p>
            <p style="margin-top:30px;font-size: 20px;">
                国家级仪器仪表防爆安全监督检验站防爆合格证书40余份。
            </p>
        </a-typography-paragraph>
    </div>
</div>

        </div>
    </div>
</template>
<script setup>
    import {reactive} from 'vue';
    let data= reactive({
        autoplaySpeedTime:10000,
        videoOpen: true,
        devHeight:670
    });

</script>

<style scoped type="less">
    .video_box {
        width: 100%;
        height: 100%;
    }

    .plugin {
        width: 100%;
        height: 100%;
    }

    .playWnd {
        margin: 0 auto;
    }
    .main_img {
        width: 92%;
        height: 2320px;
        margin: 0 auto;
        border:0px solid red;
    }

    .videoPlayer{
        height: 80vh;
        background-color: white !important;
        width: 100% !important;
        object-fit: fill;
        background-size: cover;
    }
    ::v-deep .video-js .vjs-tech {
        object-fit: fill;
    }
    ::v-deep .vjs-poster {
        background-size: cover;
    }

</style>